import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';

// export interface IFetchObjectSharingRequestTrackersStatusState {
//   value: enumWorkflowState | null
// }

const initialState: enumWorkflowState | null = null;

export const fetchObjectSharingRequestTrackersStatusSlice = createSlice({
  name: 'fetchObjectSharingRequestTrackersStatus',
  initialState: enumWorkflowState.None,
  reducers: {
    setFetchObjectSharingRequestTrackersStatus: (state: enumWorkflowState | null, action: PayloadAction<enumWorkflowState>) => {
      state = action.payload;
    },
    clearFetchObjectSharingRequestTrackersStatus: (state: enumWorkflowState | null) => {
      state = null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { setFetchObjectSharingRequestTrackersStatus, clearFetchObjectSharingRequestTrackersStatus } = fetchObjectSharingRequestTrackersStatusSlice.actions;

// export the core reducer for the slice
export const fetchObjectSharingRequestTrackersStatusReducer = fetchObjectSharingRequestTrackersStatusSlice.reducer;

export default fetchObjectSharingRequestTrackersStatusSlice.reducer;